import { CompassIcon } from '@atlaskit/logo';

import { Journeys } from '@atlassiansox/cross-flow-support/cross-flow-api-internals';

import { Targets } from '@atlassiansox/cross-flow-support/cross-flow-base-types';

import {
	AtlasSideNavAppRecommendationMenuItem,
	type ComponentProps,
} from '@post-office/browser--growth/components/atlas-side-nav-growth-item';

import { type JSX } from 'react/jsx-runtime';

const ProductLogo = () => <CompassIcon size="xsmall" appearance="brand" />;

export const AtlasSideNavRecommendationCompass = ({ ...props }: ComponentProps): JSX.Element => {
	return (
		<AtlasSideNavAppRecommendationMenuItem
			{...props}
			appName={'Compass'}
			logo={<ProductLogo />}
			targetProduct={Targets.COMPASS}
			journeyType={Journeys.GET_STARTED}
		/>
	);
};
